import React from 'react';

import imgResolver from '../utils/img-resolver';
import {gettext} from '../i18n';


class PageError extends React.Component {
    renderStatusCode() {
        try {
            const jsonErr = JSON.parse(this.props.pageFault.responseText);

            if (jsonErr && jsonErr.sentry) {
                return [
                    gettext('Fault code: #'),
                    jsonErr.sentry
                ];
            }
        } catch (e) {}  // eslint-disable-line

        return [
            gettext('Status code: '),
            this.props.pageFault.statusCode
        ];
    }

    reloadPage(e) {
        e.preventDefault();

        window.location.reload(true);
    }

    render() {
        const isDev = process.env.NODE_ENV == 'development';
        let statusCode;

        if (isDev  && this.props.pageFault) {
            console.error('PageFault', this.props.pageFault, '-', this.props.pageFault.stack);
        }

        if (this.props.pageFault && this.props.pageFault.statusCode) {
            statusCode = ` (${this.props.pageFault.statusCode})`;
        }

        return (
            <div className="page-error bg-img">
                <a href="/"><img className="logo" src={require('../styles/images/logo-color.png')} /></a>
                <div className="content">

                    <div className="content-text">
                        <p>
                            <strong>Oh snap{this.renderStatusCode()}!</strong><br />
                            Something went wrong.
                        </p>
                        <p>
                            <a className="reload-page" onClick={this.reloadPage} href="#">Please reload the page</a>
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}

PageError.propTypes = {
    pageFault: React.PropTypes.any.isRequired
};

export default PageError;



/** WEBPACK FOOTER **
 ** ./app/src/views/PageError.js
 **/